/// <amd-module name="Pipeline/Analytics/Common/Actions/PipelineReportBaseActions" />
import { ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { Action } from "VSS/Reflux/Action";

export abstract class PipelineReportBaseActions<T> {
    public updateConfigurationValuesAction: Action<ITrendChartReportConfiguration> = new Action<ITrendChartReportConfiguration>();
    public updateDataAction: Action<T> = new Action<T>();
    public onError = new Action<Error>();
}
